import { useEffect, useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import { useGetAllcompanyQuery } from "../../../../store/api/itemtaxapi"
import Table from './Table';
import ActivityCard from '../../../../Core/Activity/ActivityCard';

const Tab1 = ({ handleChange, setFormData, formdata, setSelectedtax, selectedTaxAccounts, taxId }) => {
  const [companys, setCompanys] = useState([])
  const { data: companydata, isLoading, isError } = useGetAllcompanyQuery()
  const gstOptions = [{ "name": "Taxable" }, { "name": "Nil-Rated" }, { "name": "Exmpted" }, { "name": "Non-GST" }]
  useEffect(() => {
    if (companydata) {
      setCompanys(companydata.data)
    }
  }, [companydata])
  return (
     <div>
          <div className="px-4 py-4" style={{ background: 'white' }}>
    
            <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
    
              <div className="col-md-12">
                <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
    
                  <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                    <div style={{ flex: 1 }}>
                      <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 1 }}>
                       <Input
                  name="title"
                  value={formdata.title}
                  label="Title"
                  style={{ height: "30px" }}
                  readOnly
                />
                    </div>
                    <div style={{ flex: 1 }}>
                       <Input
                  name="gst_treatment"
                  value={formdata.gst_treatment}
                  label="GST Treatment"
                  style={{ height: "30px" }}
                  readOnly
                />
                      
    
                    </div>
                    {formdata.gst_treatment == 'Taxable' && (
                    
                    <div style={{ flex: 1 }}>
                       
                         <Input
                    name="gst_rate"
                    type='number'
                    value={formdata.gst_rate}
                    label="GST Rate"
                    style={{ height: "30px" }}
                    readOnly
                  />
                    </div>
                     )}
                    <div style={{ flex: 1 }}>
                       <Input
                    name="company"
                    type='text'
                    value={formdata.company}
                    label="Company"
                    style={{ height: "30px" }}
                    readOnly
                  />
                      
                    </div> 
                    
                   
                  </div>
    
    
    
    
    
    
    
                </div>
              </div>
    
            </div>
    
           
        <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >
    
                <div className="col-md-12">
                  <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
     <div style={{ display: 'flex', gap: '15px'}}>
                    <div style={{ flex: 1 }}>
                      <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Rates</p>
                    </div>
                  </div>
    
                  <Table
            selectedTaxAccounts={selectedTaxAccounts}
          />
    
    
    
    
                  </div>
                </div>
    
              </div>
    
    
            <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Item Tax Template" docname={taxId} />
            </div>
          </div>
        </div>
            
          </div>
        </div>
  )
}

export default Tab1